import styled from 'styled-components'

import { helpers } from 'styles'

export const Content = styled.div`
	font-size: ${helpers.font.size.small};
	border-top: 1px solid ${helpers.color.warning};
	padding: 12px 12px 2px;
`
